// @ts-nocheck
import React, { useEffect, useState } from 'react';

import Btn from '../claims/shared/Btn';
import Modal from '../claims/shared/Modal';
import { labelForSectionKey } from './sectionLabels';

/**
 * Section-picker regeneration block (LTR-08). Replaces the per-card Regenerate
 * ghost button: one dropdown of the letter's sections + a Regenerate button that
 * requires a danger-confirm, then calls onRegenerateSection(selectedKey). The
 * host's whole-letter refinement regenerate is separate and untouched.
 *
 * @param {{
 *   sections: Array<{ section_key: string }>,
 *   locked?: boolean,
 *   generating?: boolean,
 *   onRegenerateSection?: (sectionKey: string) => void,
 * }} props
 */
export default function RegenerationBlock({
  sections = [],
  locked = false,
  generating = false,
  onRegenerateSection,
}) {
  const options = sections.map((s) => ({
    value: s.section_key,
    label: labelForSectionKey(s.section_key),
  }));
  const [selected, setSelected] = useState(options[0]?.value || '');
  const [open, setOpen] = useState(false);

  // Keep the selection valid as the section set changes (e.g. new version).
  const optionKeys = options.map((o) => o.value).join('|');
  useEffect(() => {
    if (!options.find((o) => o.value === selected) && options[0]) {
      setSelected(options[0].value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionKeys]);

  const disabled = locked || generating || !selected;

  const confirm = () => {
    setOpen(false);
    onRegenerateSection?.(selected);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        marginTop: 24,
        paddingTop: 16,
        borderTop: '1px solid var(--ab-border-hair)',
      }}
    >
      <span style={{ fontSize: 'var(--ab-text-sm)', color: 'var(--ab-fg-subtle)' }}>
        Regenerate a section:
      </span>
      <select
        aria-label="Section to regenerate"
        value={selected}
        disabled={disabled}
        onChange={(e) => setSelected(e.target.value)}
        style={{
          fontSize: 'var(--ab-text-sm)',
          padding: '6px 10px',
          borderRadius: 'var(--ab-radius-sm)',
          border: 'var(--ab-hairline)',
          background: 'var(--ab-bg)',
          color: 'var(--ab-fg)',
        }}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <Btn kind="secondary" size="sm" icon="refresh-cw" disabled={disabled} onClick={() => setOpen(true)}>
        Regenerate section
      </Btn>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Regenerate this section?"
        width={480}
        footer={
          <>
            <Btn kind="secondary" onClick={() => setOpen(false)}>
              Keep editing
            </Btn>
            <Btn kind="danger" onClick={confirm}>
              Regenerate section
            </Btn>
          </>
        }
      >
        <div style={{ fontSize: 'var(--ab-text-body)', color: 'var(--ab-fg)' }}>
          Your edits to this section will be replaced with newly generated text. Other sections
          are not affected.
        </div>
      </Modal>
    </div>
  );
}
